export function pluralize(count: number | undefined, singular: string, plural: string) {
  if (!count) {
    return '';
  }

  return `${count} ${count === 1 ? singular : plural}`;
}
